export default function loadingLogo() {
    const loadingLogo = document.getElementById('loadingLogo')
    const loadingLine = document.getElementById('loadingLogoLine')

    loadingLogo.classList.remove('is-loaded')
    loadingLogo.classList.add('is-reset')

    loadingLine.style.animationName = "reset"
    loadingLine.addEventListener("animationend", onLoadingAnimationEnd)

    document.documentElement.classList.remove("is-loader-complete")

    function onLoadingAnimationEnd() {
        const loadingLine = document.getElementById('loadingLogoLine')

        if (document.documentElement.classList.contains('is-loaded')) {
            loadingLogo.classList.remove('is-loading')
            loadingLogo.classList.add('is-loaded')

            loadingLine.style.animationName = "loaded"
            loadingLine.style.animationFillMode = "forwards"

            loadingLine.removeEventListener("animationend", onLoadingAnimationEnd)

            // Global loading event
            const loadingEndEvent = new CustomEvent("loadingEnd")
            setTimeout(() => {
                document.documentElement.classList.add("is-loader-complete")
                window.dispatchEvent(loadingEndEvent)
            }, 200)

        } else {
            if (!loadingLogo.classList.contains('is-loading')) {
                loadingLogo.classList.remove('is-reset')
                loadingLogo.classList.add('is-loading')
            }

            requestAnimationFrame(() => {
                loadingLine.style.animationName = "none"

                requestAnimationFrame(() => {
                    loadingLine.style.animationName = "loading"
                })
            })
        }
    }
}
